import { useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import UploadProfile from "../../components/inputs/UploadProfile";
import InputFieldFloat from "../../components/inputs/InputFieldFloat";
import Spinner from "../../components/Spinner";
import {
  useShowAdminProfileQuery,
  useAdminUpdateProfileMutation,
} from "../../services/organization/auth";

const EditProfile = () => {
  const { t } = useTranslation(["common", "profile"]);
  const { data: myProfile } = useShowAdminProfileQuery();
  const [adminUpdateProfile] = useAdminUpdateProfileMutation();

  const [image, setImage] = useState();
  const [submitting, setSubmitting] = useState(false);

  const validationSchema = yup.object({
    name: yup.string().required(t("validations.nameRequired")),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: myProfile?.data?.admin?.name || "",
    },
    validationSchema,
    onSubmit: async (form_values) => {
      setSubmitting(true);
      const dataForm = new FormData();
      dataForm.append("name", form_values.name);
      if (image) dataForm.append("avatar", image);
      const result = await adminUpdateProfile(dataForm);
      setSubmitting(false);
      if (!result?.error) {
        toast.success(t("updatedSuccessfully"));
      } else {
        toast.error(result?.error?.data?.message);
      }
    },
  });

  return (
    <div className="container-fluid profile-page">
      <div className="row justify-content-center p-4">
        <div className="col-lg-6 col-md-12">
          <div className="content-header">
            <h1 className="font-extrabold">{t("profile:editProfile")}</h1>
            <p>{t("profile:updateYourProfile")}</p>
          </div>
          <form
            className="content-form"
            onSubmit={(e) => {
              e.preventDefault();
              formik.handleSubmit(e);
            }}
          >
            <div className="row">
              <h1 className="section_label">{t("profile:personalInfo")}</h1>
              <div className="profile-page__avatar-row">
                <UploadProfile
                  avatarUrl={myProfile?.data?.admin?.avatar_url}
                  image={image}
                  setImage={setImage}
                />
                <div className="profile-page__avatar-copy d-flex flex-column justify-content-center">
                  <h4 className="gray_title">
                    {t("profile:changeProfilePicture")}
                  </h4>
                  <p className="small_hint mb-0">{t("profile:useRecentPhoto")}</p>
                </div>
              </div>
              <div className="col-12">
                <InputFieldFloat
                  label={t("profile:nameInEnglish")}
                  type="text"
                  name="name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  error={formik.errors.name}
                  touched={formik.touched.name}
                />
              </div>
              <div className="col-12">
                <InputFieldFloat
                  label={t("inputs.email")}
                  type="text"
                  name="email"
                  disabled
                  value={myProfile?.data?.admin?.email || ""}
                />
              </div>
            </div>
            <button
              type="submit"
              className="btn btn-main-color d-block w-100"
              disabled={submitting}
            >
              {t("saveInfo")}
              {submitting && (
                <Spinner
                  style={{ marginRight: "10px", width: "20px", height: "20px" }}
                />
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
